var _style, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZigZag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 563 387",
    style: {
      enableBackground: "new 0 0 563 387"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#A9A9A9;stroke-width:0.5;}\n\t.st1{fill:#66FCFC;}\n\t.st2{fill:none;stroke:#197E95;stroke-width:2;}\n\t.st3{fill:none;stroke:#66FCFC;stroke-width:0.5;}\n\t.st4{fill:none;stroke:#66FCFC;stroke-width:2;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outer_left_Line"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Top_left_Line",
    className: "st0",
    points: "122.9,233.1 316.8,39.3 125.3,39.3  "
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Outer_left_Dot_1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 196.7,
    cy: 39.3,
    r: 5
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Outer_left_Dot_2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 140.3,
    cy: 214.9,
    r: 5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Outer_left_line_overlay"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 289.2,
    y1: 66.8,
    x2: 223.2,
    y2: 132.8
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Center_left_Line"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "81.1,355.2 318.2,118 518.3,118  "
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Center_left_Dot"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 111.9,
    cy: 324.1,
    r: 5
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Center_left_line_overlay"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 184.2,
    y1: 252,
    x2: 222,
    y2: 214.2
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "Center_right_Line"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st3",
    points: "353.2,160.9 244.6,269.5 43.1,269.5  "
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "Center_right_Dot"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 339.4,
    cy: 174,
    r: 5
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "Center_right_line_overlay"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 251.4,
    y1: 262.7,
    x2: 302.5,
    y2: 211.6
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    id: "Outer_right_Line"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "518.3,74.8 273.4,319.7 496.2,319.7  "
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    id: "Outer_right_Dot"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 501.2,
    cy: 92,
    r: 5
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    id: "Outer_right_line_overlay"
  }, /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 458.6,
    y1: 134.4,
    x2: 425.3,
    y2: 167.8
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZigZag);
export default __webpack_public_path__ + "static/media/ZigZag.7d2853b05f3d0664f7579cd0d7acf055.svg";
export { ForwardRef as ReactComponent };